import { Loading } from "../../constants"

export const Loader = () => {
    return(

        <div style={{position:'fixed',left:0,right:0, top:0, bottom:0, background:'rgba(255,255,255,0.5)', display:'flex',justifyContent:'center', alignItems:'center'}}>
             <img src={Loading} style={{ height: 30 }} alt="back" />
        </div>
    )
}